import React, { useEffect, useRef, useState } from "react";
import Navbar from "../../component/Navbar/Navbar";

import { useDispatch, useSelector } from "react-redux";
import {
  deletePurchase,
  getPurchases,
  selectPurchases,
} from "../../redux/features/Purchase/PurchaseSlice";
import { NavLink } from "react-router-dom";
import { MdDelete, MdEdit, MdOutlineInventory, MdPrint } from "react-icons/md";
import dayjs from "dayjs";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import {
  filterClosePurchases,
  filterInventoryAdjusts,
  filterNewPurchases,
  filterOpenPurchases,
  selectFilteredClosePurchases,
  selectFilteredInventoryAdjusts,
  selectFilteredNewPurchases,
  selectFilteredOpenPurchases,
} from "../../redux/features/filter/FilterSlice";
import ReactPaginate from "react-paginate";
import "../Items/Items.css";
import { FaPlus } from "react-icons/fa";
import {
  getInventoryAdjusts,
  selectInventoryAdjusts,
} from "../../redux/features/inventoryAdjust/InventoryAdjustSlice";

const sidebarSections = [
  {
    name: "New Purchase",
  },
  {
    name: "Open Purchase",
  },
  {
    name: "Close Purchase",
  },
  {
    name: "Inventory Adjustment",
  },
];

const Purchase = () => {
  const purchases = useSelector(selectPurchases);
  const inventoryAdjusts = useSelector(selectInventoryAdjusts);
  const [newPurchases, setNewPurchases] = useState();
  const [openPurchases, setOpenPurchases] = useState();
  const [closePurchases, setClosePurchases] = useState();
  const printRef = useRef();
  const [printPurchase, setPrintPurchase] = useState();

  // const handlePrint = async (purchase) => {
  //   await setPrintPurchase(purchase);
  //   if (printPurchase) {
  //     const printContent = printRef.current;
  //     if (!printContent) return;
  //     const styles = Array.from(document.styleSheets)
  //       .map((sheet) => {
  //         try {
  //           return Array.from(sheet.cssRules)
  //             .map((rule) => rule.cssText)
  //             .join("\n");
  //         } catch (err) {
  //           return "";
  //         }
  //       })
  //       .join("\n");

  //     const iframe = document.createElement("iframe");
  //     document.body.appendChild(iframe);

  //     const doc = iframe.contentWindow.document;
  //     doc.open();
  //     doc.write(`
  //     <html>
  //       <head>
  //         <title>Print PDF</title>
  //        <link rel="preconnect" href="https://fonts.googleapis.com">
  //        <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
  //         <link href="https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap" rel="stylesheet">
  //       <style>
  //         ${styles}
  //         body {
  //           font-family: 'Inter';
  //           color: #000;
  //           font-weight: medium;
  //         }

  //       </style>
  //       </head>
  //       <body >${printContent.innerHTML}</body>
  //     </html>
  //   `);
  //     doc.close();

  //     iframe.contentWindow.onload = () => {
  //       iframe.contentWindow.focus();
  //       iframe.contentWindow.print();
  //       document.body.removeChild(iframe);
  //     };

  //     setPrintPurchase();
  //   }
  // };

  const printStyles = `
  @media print {
    body {
      margin: 0;
      padding: 0;
      font-family: 'Inter', sans-serif;
    }
    
    /* Ensure the content fits within one page */
    html, body {
      height: auto;
      width: 100%;
      overflow: hidden;
    }
    
    /* Prevent forced page breaks */
    * {
      page-break-inside: avoid;
    }
    
    /* Hide unnecessary elements */
    @page {
      size: auto; /* Use auto to fit content */
      margin: 0; /* Remove browser default margins */
    }
  }
`;
  const handlePrint = (purchase) => {
    setPrintPurchase(purchase);
  };

  useEffect(() => {
    if (!printPurchase) return;

    const printContent = printRef.current;
    if (!printContent) return;

    const styles = Array.from(document.styleSheets)
      .map((sheet) => {
        try {
          return Array.from(sheet.cssRules)
            .map((rule) => rule.cssText)
            .join("\n");
        } catch (err) {
          return "";
        }
      })
      .join("\n");

    const iframe = document.createElement("iframe");
    document.body.appendChild(iframe);

    const doc = iframe.contentWindow.document;
    doc.open();
    doc.write(`
      <html>
        <head>
          <title>Print PDF</title>
          <link rel="preconnect" href="https://fonts.googleapis.com">
          <link rel="preconnect" href="https://fonts.gstatic.com" crossorigin>
          <link href="https://fonts.googleapis.com/css2?family=Inter:wght@100..900&display=swap" rel="stylesheet">
          <style>
            ${styles}  
            ${printStyles}
            body {
              font-family: 'Inter', sans-serif; 
              color: #000;
              font-weight: medium;
            }
          </style>
        </head>
        <body>${printContent.innerHTML}</body>
      </html>
    `);
    doc.close();

    iframe.contentWindow.onload = () => {
      iframe.contentWindow.focus();
      iframe.contentWindow.print();
      document.body.removeChild(iframe);
    };

    setPrintPurchase(null);
  }, [printPurchase, printStyles]);

  const filterPurchases = (purchases, purchaseEditStatus, purchaseStatus) => {
    return purchases.filter((purchase) => {
      if (purchaseEditStatus) {
        return (
          purchase.purchaseEditStatus === purchaseEditStatus &&
          purchase.purchaseStatus === purchaseStatus
        );
      }
      return purchase.purchaseStatus === purchaseStatus;
    });
  };

  useEffect(() => {
    setNewPurchases(filterPurchases(purchases, true, "open"));
    setClosePurchases(filterPurchases(purchases, false, "close"));
    setOpenPurchases(filterPurchases(purchases, "", "open"));
  }, [purchases]);
  const [sidebarSection, setSidebarSection] = useState("New Purchase");
  const dispatch = useDispatch();
  const [search, setSearch] = useState();
  const [searchOpen, setSearchOpen] = useState();
  const [searchClose, setSearchClose] = useState();
  const [searchInventoryAdjust, setSearchInventoryAdjust] = useState();

  const confirmDelete = (purchaseId, purchaseNo) => {
    if (!purchaseId || !purchaseNo) {
      toast.error("ID or Purchase No is undefined");
      return;
    }
    confirmAlert({
      title: "Delete this Purchase",
      message: `Are you sure to delete this ${purchaseNo}?`,
      buttons: [
        {
          label: "Delete",
          onClick: () => removePurchase(purchaseId),
        },
        {
          label: "Cancel",
        },
      ],
    });
  };

  const removePurchase = async (purchaseId) => {
    await dispatch(deletePurchase(purchaseId));
    dispatch(getPurchases());
  };
  const filteredNewPurchases = useSelector(selectFilteredNewPurchases);
  const filteredOpenPurchases = useSelector(selectFilteredOpenPurchases);
  const filteredClosePurchases = useSelector(selectFilteredClosePurchases);
  const filteredInventoryAdjusts = useSelector(selectFilteredInventoryAdjusts);
  const [filterData, setFilterData] = useState();

  useEffect(() => {
    if (sidebarSection && sidebarSection === "New Purchase") {
      setFilterData(filteredNewPurchases);
    }
    if (sidebarSection && sidebarSection === "Open Purchase") {
      setFilterData(filteredOpenPurchases);
    }
    if (sidebarSection && sidebarSection === "Close Purchase") {
      setFilterData(filteredClosePurchases);
    }
    if (sidebarSection && sidebarSection === "Inventory Adjustment") {
      setFilterData(filteredInventoryAdjusts);
    }
  }, [
    sidebarSection,
    filteredNewPurchases,
    filteredClosePurchases,
    filteredOpenPurchases,
    filteredInventoryAdjusts,
  ]);

  // start pagination

  const itemsPerPage = 10;
  const [itemOffset, setItemOffset] = useState(0);
  const endOffset = itemOffset + itemsPerPage;
  const currentData = filterData?.slice(itemOffset, endOffset);
  const pageCount = Math.ceil(filterData?.length / itemsPerPage);

  // Invoke when user click to request another page.
  const handlePageClick = (event) => {
    const newOffset = (event.selected * itemsPerPage) % filterData?.length;

    setItemOffset(newOffset);
  };
  // end pagination

  useEffect(() => {
    dispatch(filterNewPurchases({ search, newPurchases }));
  }, [search, dispatch, newPurchases]);

  useEffect(() => {
    dispatch(filterOpenPurchases({ searchOpen, openPurchases }));
  }, [searchOpen, dispatch, openPurchases]);

  useEffect(() => {
    dispatch(filterClosePurchases({ searchClose, closePurchases }));
  }, [searchClose, dispatch, closePurchases]);

  useEffect(() => {
    dispatch(
      filterInventoryAdjusts({ searchInventoryAdjust, inventoryAdjusts })
    );
  }, [searchInventoryAdjust, dispatch, inventoryAdjusts]);

  useEffect(() => {
    dispatch(getPurchases());
    dispatch(getInventoryAdjusts());
  }, [dispatch]);

  return (
    <div className="flex flex-col h-screen bg-[#F1F1F1] overflow-hidden">
      <Navbar page="Purchase" />
      <div className="flex flex-1 overflow-hidden relative">
        <div className="md:w-[30%] w-[35%] bg-white shadow-md">
          <div>
            {sidebarSections.map((section, i) => (
              <NavLink onClick={() => setSidebarSection(section.name)} key={i}>
                <div
                  key={section}
                  className={`md:p-4 py-3 px-2 cursor-pointer md:text-[1rem] text-[.8rem] font-inter-600 flex items-center hover:bg-[#E6E6E6]   ${
                    sidebarSection === section.name
                      ? "bg-[#E6E6E6] text-[#0D868C] "
                      : "bg-white text-[#A9A9A9] "
                  }`}
                >
                  <span>{section.name}</span>
                </div>
              </NavLink>
            ))}
          </div>
        </div>

        <div className="flex-1 p-8 relative overflow-y-auto  scrollbar-hide ">
          {/* New Purchase */}

          {sidebarSection === "New Purchase" &&
            (newPurchases?.length > 0 ? (
              <>
                <div className="lg:w-full w-[37rem] mx-auto mb-10 ">
                  <div className="flex lg:justify-end justify-start my-4 items-center ">
                    <input
                      type="search"
                      value={search}
                      onChange={(e) => setSearch(e.target.value)}
                      className="bg-transparent py-2 px-4 border-2 border-[#A9A9A9]  rounded-full outline-none"
                      placeholder="Search by Purchase No..."
                    />
                  </div>
                  <div className="space-y-4">
                    {currentData?.map((purchase, index) => {
                      return (
                        <div
                          key={purchase?._id}
                          className={`flex items-start flex-col pt-4 pb-0 ${
                            index !== 0 ? "border-t-2 border-[#DEDEDE]" : ""
                          }`}
                        >
                          <div className="flex items-center justify-between w-full ">
                            <div className="flex items-center gap-4">
                              <span>{index + 1}</span>

                              <span className="font-inter-600 text-[1rem] text-wrap capitalize text-[#0D868C]">
                                Purchase No: {purchase.purchaseNo}
                              </span>
                              <span className="font-inter-600 text-[1rem] text-wrap capitalize text-[#0D868C]">
                                Date:{" "}
                                {dayjs(purchase.createdAt).format(
                                  "D/MM/YY (dddd) h:mm A "
                                )}
                              </span>
                            </div>

                            <div className="flex items-center gap-3">
                              <button onClick={() => handlePrint(purchase)}>
                                <MdPrint className="text-[#0D868C] size-6" />
                              </button>
                              <NavLink
                                to={`/editPurchase/${purchase._id}`}
                                disabled={purchase.purchaseEditStatus === false}
                                className="text-center text-[#0D868C]  cursor-pointer"
                              >
                                <MdEdit className="size-6" />
                              </NavLink>
                              <button
                                onClick={() =>
                                  confirmDelete(
                                    purchase._id,
                                    purchase?.purchaseNo
                                  )
                                }
                                disabled={!purchase.purchaseEditStatus}
                                className=" text-center text-[#0D868C] cursor-pointer"
                              >
                                <MdDelete className="size-6" />
                              </button>
                            </div>
                          </div>
                          <table className="w-full border-collapse border mt-2 border-gray-300 bg-white">
                            <thead>
                              <tr>
                                <th className="border border-gray-300 px-4 py-2 text-[.9rem] w-[50%] text-left">
                                  Name
                                </th>
                                <th className="border border-gray-300 px-4 py-2 text-[.9rem] w-[50%] text-left">
                                  Quantity
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {purchase.ingredients.length > 0 && (
                                <>
                                  <tr>
                                    <td
                                      colspan="2"
                                      className="border border-gray-300 px-4 py-1 text-[#0D868C] capitalize text-[.9rem]"
                                    >
                                      ingredient
                                    </td>
                                  </tr>
                                  {purchase?.ingredients?.map(
                                    (ingredient, i) => (
                                      <tr key={i}>
                                        <td className="border border-gray-300 px-4 py-1 text-[.8rem] capitalize">
                                          {ingredient.ingredientName}
                                        </td>
                                        <td
                                          title={`${
                                            ingredient.ingredientQuantity *
                                            ingredient?.conversionRate
                                          } ${ingredient.unitOfMeasure}`}
                                          className="border border-gray-300 px-4 py-1 text-[.8rem] capitalize"
                                        >
                                          {ingredient.ingredientQuantity}{" "}
                                          {ingredient?.purchaseUnit}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </>
                              )}

                              {purchase.items.length > 0 && (
                                <>
                                  <tr>
                                    <td
                                      colspan="2"
                                      className="border border-gray-300 px-4 py-1 text-[#0D868C] capitalize text-[.9rem]"
                                    >
                                      item
                                    </td>
                                  </tr>
                                  {purchase?.items?.map((item) => (
                                    <tr>
                                      <td className="border border-gray-300 px-4 py-1 text-[.8rem] capitalize">
                                        {item.itemName}
                                      </td>
                                      <td
                                        title={`${
                                          item.itemQuantity *
                                          item?.conversionRate
                                        } ${item.unitOfMeasure}`}
                                        className="border border-gray-300 px-4 py-1 text-[.8rem] capitalize"
                                      >
                                        {item.itemQuantity} {item?.purchaseUnit}
                                      </td>
                                    </tr>
                                  ))}
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                      );
                    })}
                  </div>
                  {filterData?.length > itemsPerPage && (
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="Next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={2}
                      pageCount={pageCount}
                      previousLabel="Prev"
                      renderOnZeroPageCount={null}
                      containerClassName="pagination"
                      pageLinkClassName="page-num"
                      previousLinkClassName="page-num"
                      nextLinkClassName="page-num"
                      activeLinkClassName="activePage"
                    />
                  )}
                </div>

                {/* Add New Item Button */}
                <NavLink
                  to={`/createPurchase`}
                  className="fixed bottom-8 right-8 md:w-14 w-10 md:h-14 h-10 bg-[#0D868C] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                >
                  <FaPlus className="md:text-xl text-[1rem]" />
                </NavLink>
              </>
            ) : (
              <div className="flex items-center justify-center ">
                <div className="w-[25rem] lg:w-[36rem]  relative  lg:h-[28rem] h-[20rem] bg-[#A9A9A9] rounded-[2.4rem] text-white flex flex-col justify-center items-center ">
                  <MdOutlineInventory className="mb-2 size-32" />

                  <p className="text-[1rem] md:text-[1.5rem] font-inter-700 text-center">
                    You have no purchase yet
                  </p>
                  <p className="text-[.8rem] md:text-[1rem] font-inter-400 text-center">
                    To add a purchase, press the (+) button
                  </p>
                  <NavLink
                    to={`/createPurchase`}
                    className=" absolute bottom-4 right-4 md:w-14 w-10 md:h-14 h-10 bg-[#0D868C] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                  >
                    <FaPlus className="md:text-xl text-[1rem]" />
                  </NavLink>
                </div>
              </div>
            ))}

          {sidebarSection === "Open Purchase" &&
            (openPurchases.length > 0 ? (
              <>
                <div className="lg:w-full w-[37rem] mx-auto mb-10 ">
                  <div className="flex lg:justify-end justify-start my-4 items-center ">
                    <input
                      type="search"
                      value={searchOpen}
                      onChange={(e) => setSearchOpen(e.target.value)}
                      className="bg-transparent py-2 px-4 border-2 border-[#A9A9A9]  rounded-full outline-none"
                      placeholder="Search by Purchase No..."
                    />
                  </div>
                  <div className="space-y-4">
                    {currentData?.map((purchase, index) => {
                      return (
                        <div
                          key={purchase?._id}
                          className={`flex items-start flex-col pt-4 pb-0 ${
                            index !== 0 ? "border-t-2 border-[#DEDEDE]" : ""
                          }`}
                        >
                          <div className="flex items-center justify-between w-full ">
                            <div className="flex items-center gap-4">
                              <span>{index + 1}</span>

                              <span className="font-inter-600 text-[1rem] text-wrap capitalize text-[#0D868C]">
                                Purchase No: {purchase.purchaseNo}
                              </span>
                              <span className="font-inter-600 text-[1rem] text-wrap capitalize text-[#0D868C]">
                                Date:{" "}
                                {dayjs(purchase.createdAt).format(
                                  "D/MM/YY (dddd) h:mm A "
                                )}
                              </span>
                            </div>
                            <div>
                              <NavLink
                                to={`/addPurchase/${purchase._id}`}
                                className="text-center text-[#0D868C]  cursor-pointer"
                              >
                                <MdEdit className="size-6" />
                              </NavLink>
                            </div>
                          </div>
                          <table className="w-full border-collapse border mt-2 border-gray-300 bg-white">
                            <thead>
                              <tr>
                                <th className="border border-gray-300 text-[.9rem] px-4 py-2 w-[25%] text-left">
                                  Name
                                </th>
                                <th className="border border-gray-300 text-[.9rem] px-4 py-2 w-[15%] text-left">
                                  Quantity
                                </th>
                                <th className="border border-gray-300 text-[.9rem] px-4 py-2 w-[25%] text-left">
                                  Receiving Qty
                                </th>
                                <th className="border border-gray-300 text-[.9rem] px-4 py-2 w-[25%] text-left">
                                  Remaining Qty
                                </th>
                                <th className="border border-gray-300 text-[.9rem] px-4 py-2 w-[10%] text-left">
                                  Status
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {purchase.ingredients.length > 0 && (
                                <>
                                  <tr>
                                    <td
                                      colspan="5"
                                      className="border border-gray-300 px-4 py-1 text-[#0D868C] capitalize text-[.9rem]"
                                    >
                                      ingredient
                                    </td>
                                  </tr>
                                  {purchase?.ingredients?.map((ingredient) => (
                                    <tr>
                                      <td className="border border-gray-300 text-[.8rem] px-4 py-1 capitalize">
                                        {ingredient.ingredientName}
                                      </td>
                                      <td
                                        title={`${
                                          ingredient.ingredientQuantity *
                                          ingredient?.conversionRate
                                        } ${ingredient.unitOfMeasure}`}
                                        className="border border-gray-300 text-[.8rem] px-4 py-1 capitalize"
                                      >
                                        {ingredient.ingredientQuantity}{" "}
                                        {ingredient?.purchaseUnit}
                                      </td>
                                      <td
                                        title={`${
                                          ingredient.ingredientReceived *
                                          ingredient?.conversionRate
                                        } ${ingredient.unitOfMeasure}`}
                                        className="border border-gray-300 text-[.8rem] px-4 py-1 capitalize"
                                      >
                                        {ingredient.ingredientReceived}{" "}
                                        {ingredient?.purchaseUnit}
                                      </td>
                                      <td
                                        title={`${
                                          ingredient.ingredientRemaining *
                                          ingredient?.conversionRate
                                        } ${ingredient.unitOfMeasure}`}
                                        className="border border-gray-300 text-[.8rem] px-4 py-1 capitalize"
                                      >
                                        {ingredient.ingredientRemaining}{" "}
                                        {ingredient?.purchaseUnit}
                                      </td>
                                      <td className="border border-gray-300 text-[.8rem] px-4 py-1 capitalize">
                                        {ingredient.ingredientStatus}
                                      </td>
                                    </tr>
                                  ))}
                                </>
                              )}

                              {purchase.items.length > 0 && (
                                <>
                                  <tr>
                                    <td
                                      colspan="5"
                                      className="border border-gray-300 px-4 py-1 text-[#0D868C] capitalize text-[.9rem]"
                                    >
                                      item
                                    </td>
                                  </tr>
                                  {purchase?.items?.map((item) => (
                                    <tr>
                                      <td className="border border-gray-300 px-4 text-[.8rem] py-1 capitalize">
                                        {item.itemName}
                                      </td>
                                      <td
                                        title={`${
                                          item.itemQuantity *
                                          item?.conversionRate
                                        } ${item?.unitOfMeasure}`}
                                        className="border border-gray-300 px-4 text-[.8rem] py-1 capitalize"
                                      >
                                        {item.itemQuantity} {item?.purchaseUnit}
                                      </td>
                                      <td
                                        title={`${
                                          item.itemReceived *
                                          item?.conversionRate
                                        } ${item?.unitOfMeasure}`}
                                        className="border border-gray-300 px-4 text-[.8rem] py-1 capitalize"
                                      >
                                        {item.itemReceived} {item?.purchaseUnit}
                                      </td>
                                      <td
                                        title={`${
                                          item.itemRemaining *
                                          item?.conversionRate
                                        } ${item?.unitOfMeasure}`}
                                        className="border border-gray-300 px-4 text-[.8rem] py-1 capitalize"
                                      >
                                        {item.itemRemaining}{" "}
                                        {item?.purchaseUnit}
                                      </td>
                                      <td className="border border-gray-300 px-4 text-[.8rem] py-1 capitalize">
                                        {item.itemStatus}
                                      </td>
                                    </tr>
                                  ))}
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                      );
                    })}
                  </div>
                  {filterData?.length > itemsPerPage && (
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="Next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={2}
                      pageCount={pageCount}
                      previousLabel="Prev"
                      renderOnZeroPageCount={null}
                      containerClassName="pagination"
                      pageLinkClassName="page-num"
                      previousLinkClassName="page-num"
                      nextLinkClassName="page-num"
                      activeLinkClassName="activePage"
                    />
                  )}
                </div>
              </>
            ) : (
              <div className="p-4 text-[2rem] text-[#6b6868] capitalize">
                no Open purchase Found
              </div>
            ))}
          {sidebarSection === "Close Purchase" &&
            (closePurchases.length > 0 ? (
              <>
                <div className="lg:w-full w-[37rem] mx-auto mb-10 ">
                  <div className="flex lg:justify-end justify-start my-4 items-center ">
                    <input
                      type="search"
                      value={searchClose}
                      onChange={(e) => setSearchClose(e.target.value)}
                      className="bg-transparent py-2 px-4 border-2 border-[#A9A9A9]  rounded-full outline-none"
                      placeholder="Search by Purchase No..."
                    />
                  </div>
                  <div className="space-y-4">
                    {currentData?.map((purchase, index) => {
                      return (
                        <div
                          key={purchase?._id}
                          className={`flex items-start flex-col pt-4 pb-0 ${
                            index !== 0 ? "border-t-2 border-[#DEDEDE]" : ""
                          }`}
                        >
                          <div className="flex items-center justify-between w-full ">
                            <div className="flex items-center gap-4">
                              <span>{index + 1}</span>

                              <span className="font-inter-600 text-[1rem] text-wrap capitalize text-[#0D868C]">
                                Purchase No: {purchase.purchaseNo}
                              </span>
                              <span className="font-inter-600 text-[1rem] text-wrap capitalize text-[#0D868C]">
                                Date:{" "}
                                {dayjs(purchase.createdAt).format(
                                  "D/MM/YY (dddd) h:mm A "
                                )}
                              </span>
                            </div>
                          </div>
                          <table className="w-full border-collapse border mt-2 border-gray-300 bg-white">
                            <thead>
                              <tr>
                                <th className="border border-gray-300 text-[.9rem] px-4 py-2 w-[50%] text-left">
                                  Name
                                </th>
                                <th className="border border-gray-300 text-[.9rem] px-4 py-2 w-[50%] text-left">
                                  Quantity
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {purchase.ingredients.length > 0 && (
                                <>
                                  <tr>
                                    <td
                                      colspan="2"
                                      className="border border-gray-300 px-4 py-1 text-[#0D868C] capitalize text-[.9rem]"
                                    >
                                      ingredient
                                    </td>
                                  </tr>
                                  {purchase?.ingredients?.map((ingredient) => (
                                    <tr>
                                      <td className="border border-gray-300 text-[.8rem] px-4 py-1 capitalize">
                                        {ingredient.ingredientName}
                                      </td>
                                      <td
                                        title={`${
                                          ingredient?.ingredientQuantity *
                                          ingredient?.conversionRate
                                        } ${ingredient?.unitOfMeasure}`}
                                        className="border border-gray-300 text-[.8rem] px-4 py-1 capitalize"
                                      >
                                        {ingredient?.ingredientQuantity}{" "}
                                        {ingredient?.purchaseUnit}
                                      </td>
                                    </tr>
                                  ))}
                                </>
                              )}

                              {purchase.items.length > 0 && (
                                <>
                                  <tr>
                                    <td
                                      colspan="2"
                                      className="border border-gray-300 px-4 py-1 text-[#0D868C] capitalize text-[.9rem]"
                                    >
                                      item
                                    </td>
                                  </tr>
                                  {purchase?.items?.map((item) => (
                                    <tr>
                                      <td className="border border-gray-300 px-4 text-[.8rem] py-1 capitalize">
                                        {item.itemName}
                                      </td>
                                      <td
                                        title={`${
                                          item?.itemQuantity *
                                          item?.conversionRate
                                        } ${item?.unitOfMeasure}`}
                                        className="border border-gray-300 px-4 text-[.8rem] py-1 capitalize"
                                      >
                                        {item?.itemQuantity}{" "}
                                        {item?.purchaseUnit}
                                      </td>
                                    </tr>
                                  ))}
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                      );
                    })}
                  </div>
                  {filterData?.length > itemsPerPage && (
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="Next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={2}
                      pageCount={pageCount}
                      previousLabel="Prev"
                      renderOnZeroPageCount={null}
                      containerClassName="pagination"
                      pageLinkClassName="page-num"
                      previousLinkClassName="page-num"
                      nextLinkClassName="page-num"
                      activeLinkClassName="activePage"
                    />
                  )}
                </div>
              </>
            ) : (
              <div className="p-4 text-[2rem] text-[#6b6868] capitalize">
                no close purchase Found
              </div>
            ))}

          {sidebarSection === "Inventory Adjustment" &&
            (inventoryAdjusts.length > 0 ? (
              <>
                <div className="lg:w-full w-[37rem] mx-auto mb-10 ">
                  <div className="flex lg:justify-end justify-start my-4 items-center ">
                    <input
                      type="search"
                      value={searchInventoryAdjust}
                      onChange={(e) => setSearchInventoryAdjust(e.target.value)}
                      className="bg-transparent py-2 px-4 border-2 border-[#A9A9A9]  rounded-full outline-none"
                      placeholder="Search by Inventory Adjust No..."
                    />
                  </div>
                  <div className="space-y-4">
                    {currentData?.map((inventoryAdjust, index) => {
                      return (
                        <div
                          key={inventoryAdjust?._id}
                          className={`flex items-start flex-col pt-4 pb-0 ${
                            index !== 0 ? "border-t-2 border-[#DEDEDE]" : ""
                          }`}
                        >
                          <div className="flex items-center justify-between w-full ">
                            <div className="flex items-center gap-4">
                              <span>{index + 1}</span>
                              {inventoryAdjust?.inventoryAdjustNo && (
                                <span className="font-inter-600 text-[1rem] text-wrap capitalize text-[#0D868C]">
                                  Inventory Adjust No:{" "}
                                  {inventoryAdjust?.inventoryAdjustNo}
                                </span>
                              )}

                              <span className="font-inter-600 text-[1rem] text-wrap capitalize text-[#0D868C]">
                                Date:{" "}
                                {dayjs(inventoryAdjust.createdAt).format(
                                  "D/MM/YY (dddd) h:mm A "
                                )}
                              </span>
                            </div>
                          </div>
                          <table className="w-full border-collapse border mt-2 border-gray-300 bg-white">
                            <thead>
                              <tr>
                                <th className="border border-gray-300 text-[.9rem] px-4 py-2 w-[50%] text-left">
                                  Name
                                </th>
                                <th className="border border-gray-300 text-[.9rem] px-4 py-2 w-[25%] text-left">
                                  In
                                </th>
                                <th className="border border-gray-300 text-[.9rem] px-4 py-2 w-[25%] text-left">
                                  Out
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {inventoryAdjust.ingredients.length > 0 && (
                                <>
                                  <tr>
                                    <td
                                      colspan="3"
                                      className="border border-gray-300 px-4 py-1 text-[#0D868C] capitalize text-[.9rem]"
                                    >
                                      ingredient
                                    </td>
                                  </tr>
                                  {inventoryAdjust?.ingredients?.map(
                                    (ingredient) => (
                                      <tr>
                                        <td className="border border-gray-300 text-[.8rem] px-4 py-1 capitalize">
                                          {ingredient.ingredientName}
                                        </td>
                                        <td
                                          title={`${
                                            ingredient?.ingredientIn *
                                            ingredient?.conversionRate
                                          } ${ingredient?.unitOfMeasure}`}
                                          className="border border-gray-300 text-[.8rem] px-4 py-1 capitalize"
                                        >
                                          {ingredient?.ingredientIn}{" "}
                                          {ingredient?.purchaseUnit}
                                        </td>
                                        <td
                                          title={`${
                                            ingredient?.ingredientOut *
                                            ingredient?.conversionRate
                                          } ${ingredient?.unitOfMeasure}`}
                                          className="border border-gray-300 text-[.8rem] px-4 py-1 capitalize"
                                        >
                                          {ingredient?.ingredientOut}{" "}
                                          {ingredient?.purchaseUnit}
                                        </td>
                                      </tr>
                                    )
                                  )}
                                </>
                              )}

                              {inventoryAdjust.items.length > 0 && (
                                <>
                                  <tr>
                                    <td
                                      colspan="3"
                                      className="border border-gray-300 px-4 py-1 text-[#0D868C] capitalize text-[.9rem]"
                                    >
                                      item
                                    </td>
                                  </tr>
                                  {inventoryAdjust?.items?.map((item) => (
                                    <tr>
                                      <td className="border border-gray-300 px-4 text-[.8rem] py-1 capitalize">
                                        {item.itemName}
                                      </td>
                                      <td
                                        title={`${
                                          item?.itemIn * item?.conversionRate
                                        } ${item?.unitOfMeasure}`}
                                        className="border border-gray-300 px-4 text-[.8rem] py-1 capitalize"
                                      >
                                        {item?.itemIn} {item?.purchaseUnit}
                                      </td>
                                      <td
                                        title={`${
                                          item?.itemOut * item?.conversionRate
                                        } ${item?.unitOfMeasure}`}
                                        className="border border-gray-300 px-4 text-[.8rem] py-1 capitalize"
                                      >
                                        {item?.itemOut} {item?.purchaseUnit}
                                      </td>
                                    </tr>
                                  ))}
                                </>
                              )}
                            </tbody>
                          </table>
                        </div>
                      );
                    })}
                  </div>
                  {filterData?.length > itemsPerPage && (
                    <ReactPaginate
                      breakLabel="..."
                      nextLabel="Next"
                      onPageChange={handlePageClick}
                      pageRangeDisplayed={2}
                      pageCount={pageCount}
                      previousLabel="Prev"
                      renderOnZeroPageCount={null}
                      containerClassName="pagination"
                      pageLinkClassName="page-num"
                      previousLinkClassName="page-num"
                      nextLinkClassName="page-num"
                      activeLinkClassName="activePage"
                    />
                  )}
                </div>
                <NavLink
                  to={`/createInventoryAdjustment`}
                  className="fixed bottom-8 right-8 md:w-14 w-10 md:h-14 h-10 bg-[#0D868C] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                >
                  <FaPlus className="md:text-xl text-[1rem]" />
                </NavLink>
              </>
            ) : (
              <div className="p-4 text-[2rem] relative text-[#6b6868] capitalize">
                No inventory Adjustment Found
                <NavLink
                  to={`/createInventoryAdjustment`}
                  className="fixed bottom-8 right-8 md:w-14 w-10 md:h-14 h-10 bg-[#0D868C] text-white rounded-full shadow-lg flex items-center justify-center hover:bg-teal-600 focus:outline-none focus:ring-2 focus:ring-teal-500 focus:ring-offset-2"
                >
                  <FaPlus className="md:text-xl text-[1rem]" />
                </NavLink>
              </div>
            ))}
        </div>
      </div>
      <div className="hidden invisible">
        <div ref={printRef} className="flex justify-center items-center">
          {printPurchase && (
            <div className="flex flex-col px-1 my-1 gap-1 ">
              <div className="text-center">Al-Noor Restaurant</div>
              <div className="text-xs">
                Date:{" "}
                {dayjs(printPurchase?.createdAt).format(
                  "D/MM/YY (dddd) h:mm A "
                )}
              </div>
              <div className="text-sm">
                Purchase No: {printPurchase?.purchaseNo}
              </div>
              <div className="flex-col border border-b-0 border-black">
                <div className="flex justify-center items-center w-full text-sm border-b border-black">
                  <div className="w-[65%] pl-1">Name</div>
                  <div className="w-[35%]">Qty</div>
                  {/* <div className="w-[25%]">Rec Qty</div> */}
                </div>
                <div className="flex flex-col text-sm">
                  {printPurchase?.ingredients.length > 0 && (
                    <>
                      {/* <div>Ingredients</div> */}
                      {printPurchase?.ingredients?.map((ingredient, i) => (
                        <div
                          key={i}
                          className="flex justify-center items-center w-full text-sm border-b border-black"
                        >
                          <div className="w-[65%] capitalize pl-1">
                            {ingredient.ingredientName}
                          </div>
                          <div className="w-[35%] capitalize">
                            {ingredient?.ingredientQuantity}{" "}
                            {ingredient?.purchaseUnit}
                          </div>
                          {/* <div className="w-[25%]"></div> */}
                        </div>
                      ))}
                    </>
                  )}

                  {printPurchase?.items.length > 0 && (
                    <>
                      {/* <div>Items</div> */}
                      {printPurchase?.items?.map((item, i) => (
                        <div
                          key={i}
                          className="flex justify-center items-center w-full text-sm border-b border-black"
                        >
                          <div className="w-[65%] capitalize pl-1">
                            {item.itemName}
                          </div>
                          <div className="w-[35%] capitalize">
                            {item.itemQuantity} {item?.purchaseUnit}
                          </div>
                          {/* <div className="w-[25%]"></div> */}
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Purchase;
